export default "__VITE_ASSET__ByI6ccW9__"